import { NavItem } from './../nav-item';
import { Component, Input, OnInit, ViewChild, Output, EventEmitter } from '@angular/core';
@Component({
	selector: 'common-menu',
	templateUrl: './menu.component.html',
	styleUrls: ['./menu.component.scss']
})
export class MenuComponent implements OnInit {
	@Input() items: NavItem[];
	@Input() activeNode: NavItem[];
	@Output() fromChild = new EventEmitter();
	@ViewChild('childMenu', { static: true }) public childMenu: NavItem;
	constructor() {}

	ngOnInit() {}
	subscripts(i: number, node: NavItem) {
		this.fromChild.emit(node);
	}
	fromChildFunc(item: NavItem) {
		this.fromChild.emit(item);
	}
}
